module.exports = __webpack_public_path__ + "img/declaracion_patrimonial_fecc.bed19569.png";